import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import ThirdPartySku from '../entities/front-thirdparty'
import appconst from '@/lib/appconst';


interface FrontThirdSkuState extends ListState<ThirdPartySku> {


}

class FrontStockMutations extends ListMutations<ThirdPartySku>{

}
class FrontThirdSku extends ListModule<FrontThirdSkuState, any, ThirdPartySku>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ThirdPartySku>(),
        loading: false,
        id: 0,
        sku: ''
    }
    actions = {
        async getAll(context: ActionContext<FrontThirdSkuState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontSkuMapping/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<ThirdPartySku>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },
        async delData(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontSkuMapping/Delete?id=' + payload.data.id);

        }
        //async EditStock(state: any, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/FrontStock/EditStock', payload.data);
        //},
        //async supplementStockInfo(state: any, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/FrontStock/SupplementStockInfo', payload.data);
        //},

    };
    mutations = {
        setCurrentPage(state: FrontThirdSkuState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontThirdSkuState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const frontthirdskus = new FrontThirdSku();
export default frontthirdskus;